var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modalExportFile",
          attrs: {
            id: "modal-export-file",
            size: "md",
            title: "Экспорт файла",
            "ok-only": false,
            "no-fade": true,
            "button-size": "sm",
            "ok-title": "Экспортировать",
            "cancel-title": "Отменить"
          },
          on: {
            ok: _vm.okHandler,
            cancel: _vm.cancelHandler,
            close: _vm.cancelHandler,
            hide: _vm.cancelHandler
          }
        },
        [
          _c(
            "b-form-checkbox",
            {
              staticClass: "mb-3",
              attrs: {
                id: "checkbox-stamp",
                name: "checkbox-stamp",
                switch: "",
                size: "md"
              },
              model: {
                value: _vm.hasStamp,
                callback: function($$v) {
                  _vm.hasStamp = $$v
                },
                expression: "hasStamp"
              }
            },
            [_vm._v("\n      Подпись и печать\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e8a188e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e8a188e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices/ExportFile.vue
// module id = null
// module chunks = 